export enum EscriptTriageReasons {
  patientMatch = 'patientMatch',
  customerUnknown = 'customerUnknown',
  missingDaysSupply = 'missingDaysSupply',
  unexpectedError = 'unexpectedError',
  other = 'other',
}
